import { render } from "./ScriptsView.vue?vue&type=template&id=8876ba3c&scoped=true&ts=true"
import script from "./ScriptsView.vue?vue&type=script&lang=ts"
export * from "./ScriptsView.vue?vue&type=script&lang=ts"

import "./ScriptsView.vue?vue&type=style&index=0&id=8876ba3c&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8876ba3c"]])

export default __exports__